export default "__VITE_ASSET__CIWO7SZs__ 430w";